var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("div", { staticClass: "nav" }, [_c("schj-nav")], 1),
      _c(
        "el-container",
        { staticClass: "main" },
        [
          _c("el-main", [
            _c(
              "div",
              { staticClass: "content" },
              [_c(_vm.component, { tag: "component" })],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }